const PAYMENT_COLLECTION_STATUSES = new Set(["requires_payment_method"]);
const SAVED_METHOD_CONFIRMATION_STATUSES = new Set(["requires_action", "requires_confirmation"]);
const COMPLETED_PAYMENT_STATUSES = new Set(["succeeded", "processing", "requires_capture"]);

function normaliseStatus(value) {
  return typeof value === "string" ? value.trim().toLowerCase() : "";
}

export function resolvePurchasePaymentStep(paymentResponse = {}) {
  const status = normaliseStatus(paymentResponse.status);
  const clientSecret = typeof paymentResponse.client_secret === "string"
    ? paymentResponse.client_secret.trim()
    : "";
  const paymentIntentId = typeof paymentResponse.payment_intent_id === "string"
    ? paymentResponse.payment_intent_id.trim()
    : "";

  if (!paymentIntentId) {
    throw new Error("The purchase payment intent is missing.");
  }

  if (PAYMENT_COLLECTION_STATUSES.has(status)) {
    if (!clientSecret) {
      throw new Error("The secure payment form could not be initialised.");
    }
    return { type: "collect_payment_method", clientSecret, paymentIntentId };
  }

  if (SAVED_METHOD_CONFIRMATION_STATUSES.has(status)) {
    if (!clientSecret) {
      throw new Error("The payment confirmation could not be initialised.");
    }
    return { type: "confirm_saved_payment_method", clientSecret, paymentIntentId };
  }

  if (COMPLETED_PAYMENT_STATUSES.has(status)) {
    return { type: "await_order_confirmation", paymentIntentId };
  }

  throw new Error("The payment could not be prepared. Please try again.");
}

export function isTerminalPaymentFailure(status) {
  return ["canceled", "requires_payment_method"].includes(normaliseStatus(status));
}
